<template>
   <v-container fluid> 

        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>

        <v-tabs v-model="tab" v-if="!loading">
        <v-tab href="#phase1" @click="refreshPhase1" v-show="assessment.assessmentType==0 || assessment.assessmentType==2">{{ $t('wkt.admin.survey.stats.question-overview.tab.self-appraisal') }}</v-tab>
        <v-tab href="#phase2" @click="refreshPhase2" v-show="assessment.assessmentType==1 || assessment.assessmentType==2">{{ $t('wkt.admin.survey.stats.question-overview.tab.final-evaluation') }}</v-tab>
        </v-tabs>

        <v-tabs-items v-if="!loading" v-model="tab">
            <v-tab-item value="phase1">
                <QuestionOverview  ref="questionOverview1"/>
            </v-tab-item>
            <v-tab-item value="phase2">
                <QuestionOverview  ref="questionOverview2"/>
            </v-tab-item>
        </v-tabs-items>


        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">Cerrar</span>
                </v-btn>
            </v-snackbar>
            
    </v-container>
</template>

<script> 

import QuestionOverview from "./stats/QuestionOverview";
import api from '../../api/worktime'

export default {
  name: 'AssessmentStatsModule',
  assessment: null,
  components: { 
    QuestionOverview
  },
  
  data() {
      return {
        tab: null,
        loading: true,
        submissionInfo: {},
        showAlert: false,
        alertColor: 'error',
        alertText: '',
        alertTimeout: 3000,
        assessment: {
            assessmentType: -1
        }
      }
  },
   methods: {
       doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    refreshPhase1() {
        let me = this;
        setTimeout (function () {
                        me.$refs.questionOverview1.refresh({
                            currentResponses: me.assessment.phase1Reviews,
                            expectedResponses: me.assessment.expectedReviews
                        }, {
                            survey: me.assessment,
                            form: me.submissionInfo.phase1Form,
                            submissions: me.submissionInfo.phase1Submissions
                        });
                    },200);
    },
    refreshPhase2() {
         let me = this;
        setTimeout (function () {
                        me.$refs.questionOverview2.refresh({
                            currentResponses: me.assessment.phase2Reviews,
                            expectedResponses: me.assessment.expectedReviews
                        }, {
                            survey: me.assessment,
                            form: me.submissionInfo.phase2Form,
                            submissions: me.submissionInfo.phase2Submissions
                        });
                    },200);
    },
    applyDefinition() {

        if (this.assessment.assessmentType==0 || this.assessment.assessmentType==2)
        {
            this.tab='phase1';
            this.refreshPhase1();
        }
        else
        {
            this.tab='phase2';
            this.refreshPhase2();
        }
    },
    loadSubmissions() {
        this.loading=true;
        let me = this;
        api.getAssessmentSubmissions(me.assessment.id,
				data => {
					me.submissionInfo=data;
                    me.assessment=data.assessment;
                    me.loading=false;
                    me.applyDefinition();
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
    },
    onReveal(assessment) {
        this.assessment=assessment;
        this.loadSubmissions();
    }
   },
};
</script>
